import { useLang } from "../lang";
import { useDatasheet, postLead } from "./DatasheetContext";
import { useAuth } from "../auth";

// Datasheet downloads hidden on request; set true to restore
export const DATASHEETS_ENABLED = false;

export default function DatasheetLink({ url, slug, name, className = "a-link", testId, children }) {
  const { lang } = useLang();
  const { lead, openGate } = useDatasheet();
  const { user } = useAuth();
  const sheet = { url, slug, name };

  const onClick = (e) => {
    if (user) return;
    if (lead) {
      postLead(lead, sheet, lang).catch(() => {});
      return;
    }
    e.preventDefault();
    openGate(sheet);
  };

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" onClick={onClick} className={className} data-testid={testId}>
      {children}
    </a>
  );
}
